import React from 'react';
import { observer } from 'mobx-react';

import { EpgContextProvider } from 'context/epgContext/epgContext';

import EpgInner from './components/EpgInner/EpgInner';
import { useEpgHooksCombiner } from './hooks';

type Props = { referenceId: string };

function Epg({ referenceId }: Props) {
  const {
    setUserActive,
    forwardGridMovement,
    setFirstVisibleIndex,
    handleRef,
    nowLineRef,
    epgParams,
    gridStartYPosition,
    userActive,
    refTime,
    ref,
    settings,
    channels,
    isLoading,
  } = useEpgHooksCombiner(referenceId);

  return (
    <EpgContextProvider
      epgRef={ref}
      nowLineRef={nowLineRef}
      forwardGridMovement={forwardGridMovement}
      epgParams={epgParams}
      refTime={refTime}
      userActive={userActive}
      gridStartYPosition={gridStartYPosition}
      handleRef={handleRef}
      setUserActive={setUserActive}
      setFirstVisibleIndex={setFirstVisibleIndex}
      settings={settings!}
      channels={channels}
      isReadyTvChannel={!isLoading}
    >
      <EpgInner />
    </EpgContextProvider>
  );
}

export default observer(Epg);
